import { render, staticRenderFns } from "./ValidationMessage.vue?vue&type=template&id=b3107a66&scoped=true"
import script from "./ValidationMessage.vue?vue&type=script&lang=js"
export * from "./ValidationMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3107a66",
  null
  
)

export default component.exports